import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
} from "@mui/material";
import {
  ImageCropInfos,
  ImageDetails,
} from "../models/ResponseModels/DetailsImageResponse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import config from "../config";
import TemplateRowForm from "./TemplateRowForm";

interface Props {
  uuid: string;
  savedCrops: ImageCropInfos;
  realtivePath: string;
  imageDetails: ImageDetails;
  imageName: string;
  fileName: string;
  isDownloadable: boolean;
}

export default function ImageCropDownload(props: Props) {
  return (
    <div id="crops-container" className="p-4">
      {props.savedCrops != null && (
        <div>
          {Object.keys(props.savedCrops).map((aspectRatio, accordionIdx) => (
            <Accordion key={"accordion_ratio_" + aspectRatio}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={"accordion_ratio_" + accordionIdx}
                id={"accordion_ratio_" + accordionIdx}
                key={"accordion_summary_ratio_" + aspectRatio}
              >
                <div className="ml-auto mr-auto ">{aspectRatio}</div>
              </AccordionSummary>
              <AccordionDetails>
                <div id="preview-box">
                  <div
                    id="image-crop-preview"
                    className=" w-[100px] h-[100px] ml-auto mr-auto bg-contain bg-no-repeat bg-center rounded"
                    style={{
                      backgroundImage: `url(${
                        props.savedCrops[aspectRatio].previewUrl != null
                          ? props.savedCrops[aspectRatio].previewUrl
                          : config.placeholderImageUrl
                      })`,
                    }}
                  ></div>
                </div>

                <div id="templates-container" className="mt-3 ">
                  {props.savedCrops[aspectRatio].savedTemplates.length > 0 ? (
                    props.savedCrops[aspectRatio].savedTemplates.map(
                      (template, templateIdx) => (
                        <div
                          id={
                            "templates-row-" + accordionIdx + "-" + templateIdx
                          }
                          key={
                            "templates-row-" + accordionIdx + "-" + templateIdx
                          }
                          className="border-b flex flex-row flex-wrap space-between p-4 "
                        >
                          <div
                            id={"row-label-" + accordionIdx + "-" + templateIdx}
                            key={
                              "row-label-" + accordionIdx + "-" + templateIdx
                            }
                            className="font-skyBold text-lg   w-full md:w-1/2"
                          >
                            {template.label ? template.label : ""}
                          </div>

                          <div
                            id={
                              "download-form-" +
                              accordionIdx +
                              "-" +
                              templateIdx
                            }
                            key={
                              "download-form-" +
                              accordionIdx +
                              "-" +
                              templateIdx
                            }
                            className="w-full md:w-1/2"
                          >
                            {props.isDownloadable && (
                              <TemplateRowForm
                                resolution={template.resolution}
                                ratio={aspectRatio}
                                previewUrl={
                                  props.savedCrops[aspectRatio].previewUrl
                                }
                                template={template.name}
                                uuid={props.uuid}
                                fileName={props.fileName}
                              ></TemplateRowForm>
                            )}
                          </div>
                        </div>
                      ),
                    )
                  ) : (
                    <Alert severity="error" className="mt-5 mx-5">
                      No templates available
                    </Alert>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      )}
    </div>
  );
}
